import React from 'react';
import PropTypes from 'prop-types';
import { TableHead, TableRow } from '@mui/material';
import { StyledTableCell } from 'shared/components/Table';
import { useAuthUser } from '@crema/utility/AuthHooks';

const ListViewHeader = ({ filter, isCreate, isMonitoring }) => {
  const { user } = useAuthUser()

  const isBulk = user.roles_coofis.some(item => item.state === 'BULK_DIGISIGN')
  
  return (
    <TableHead>
      <TableRow>
        {filter == 'sk-need-sign'&& isBulk && (
          <StyledTableCell align='center' sx={{ width: 50 }}></StyledTableCell>
        )}
        <StyledTableCell align='center' sx={{ width: 50 }}>
          NO
        </StyledTableCell>
        {(filter === 'composer' || filter === 'completed') && user.nip !== '88888' && !isCreate && !isMonitoring && <StyledTableCell align='center' sx={{ width: 100 }}>TANGGAL PARAF</StyledTableCell>}
        <StyledTableCell align='center' sx={{ width: 100 }}>
          APPROVAL
        </StyledTableCell>
        <StyledTableCell align='center'>JUDUL DOKUMEN</StyledTableCell>
        <StyledTableCell align='center' sx={{ width: 200 }}>
          OPERATOR
        </StyledTableCell>
        {(filter === 'composer') && (
          <>
            <StyledTableCell align='center' sx={{ width: 100 }}>RIWAYAT</StyledTableCell>
            <StyledTableCell align='center' sx={{ width: 150 }}>STATUS</StyledTableCell>
          </>
        )}
        {filter !== 'draft' && (
          <StyledTableCell align='center' sx={{ width: 50 }}>
            AKSI
          </StyledTableCell>
        )}
      </TableRow>
    </TableHead>
  );
};

export default ListViewHeader;

ListViewHeader.propTypes = {
  filter: PropTypes.string,
  isCreate: PropTypes.any,
  isMonitoring: PropTypes.any
};
